import { Link } from "react-router-dom";
import { stats } from "@/mocks/archive";

export default function HomeHero() {
  return (
    <section className="relative h-[560px] md:h-[680px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20atmospheric%20scene%20of%20drifting%20smoke%20and%20faint%20amber%20embers%20suspended%20in%20deep%20shadow%2C%20minimal%20cinematic%20background%2C%20subtle%20golden%20rim%20light%20glowing%20along%20a%20distant%20horizon%2C%20high%20contrast%20between%20dark%20expanse%20and%20warm%20light%2C%20no%20people%2C%20elegant%20mysterious%20mood%20with%20fine%20film%20grain&width=1600&height=900&seq=anxian-hero&orientation=landscape"
        alt="暗线档案首屏背景：暖色调微光穿透深色烟雾与阴影的抽象影像"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/70 to-background-50"></div>

      <div className="relative z-10 w-full h-full flex flex-col justify-center px-4 md:px-8 pb-28 md:pb-24">
        <div className="max-w-4xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-primary-700/60 bg-primary-950/50 text-xs text-primary-300">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            自 2019 年持续整理 · 每季度复核
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl font-black leading-tight text-foreground-950">
            暗线档案
            <span className="mt-3 block text-xl md:text-3xl font-semibold text-primary-400">
              按时间线梳理暗黑史与未解之谜
            </span>
          </h1>

          <p className="mt-6 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600">
            从古代文明的湮灭到近现代的技术事故，我们把散落在不同资料里的信息还原成一条条可以顺序阅读的时间轴。
            每一条档案都标注哪些是已确认的记录、哪些仍是开放的推断，让你看清事件演变的完整脉络。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <Link
              to="/timeline"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer bg-primary-500 text-background-950 hover:bg-primary-400 transition-colors"
            >
              <i className="ri-git-branch-line" aria-hidden="true"></i>
              进入暗黑时间轴
            </Link>
            <Link
              to="/archive"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer border border-foreground-700/50 text-foreground-800 hover:bg-background-100/60 transition-colors"
            >
              <i className="ri-folder-history-line" aria-hidden="true"></i>
              浏览档案库
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 inset-x-0 z-10 border-t border-background-200/60 bg-background-50/80 backdrop-blur-sm">
        <div className="w-full px-4 md:px-8">
          <dl className="grid grid-cols-2 md:grid-cols-4 divide-x divide-background-200/60">
            {stats.map((item) => (
              <div key={item.label} className="px-4 py-5">
                <dt className="text-xs text-foreground-500">{item.label}</dt>
                <dd className="mt-1 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                  {item.value}
                  <span className="ml-1 text-sm font-normal text-primary-400">{item.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}